export const MEMO_CREATE_REQUESTED = 'MEMO_CREATE_REQUESTED';
export const MEMO_CREATE_SUCCEED = 'MEMO_CREATE_SUCCEED';
export const MEMO_CREATE_FAILED = 'MEMO_CREATE_FAILED';

export const MEMO_GET_REQUESTED = 'MEMO_GET_REQUESTED';
export const MEMO_GET_SUCCEED = 'MEMO_GET_SUCCEED';
export const MEMO_GET_FAILED = 'MEMO_GET_FAILED';

export const MEMOS_GET_REQUESTED = 'MEMOS_GET_REQUESTED';
export const MEMOS_GET_SUCCEED = 'MEMOS_GET_SUCCEED';
export const MEMOS_GET_FAILED = 'MEMOS_GET_FAILED';

export const MEMO_FEE_UPDATE_REQUESTED = 'MEMO_FEE_UPDATE_REQUESTED';
export const MEMO_FEE_UPDATE_SUCCEED = 'MEMO_FEE_UPDATE_SUCCEED';
export const MEMO_FEE_UPDATE_FAILED = 'MEMO_FEE_UPDATE_FAILED';
